"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
const truncate = (length, a) => {
    if (a.length <= length) {
        return a.slice();
    }
    const maxLength = length - 3;
    let trimmedString = a.substr(0, maxLength);
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')));
    return `${trimmedString}...`;
};
exports.truncate = truncate;
